import { render, staticRenderFns } from "./awards.vue?vue&type=template&id=29a791b8&scoped=true&"
import script from "./awards.vue?vue&type=script&lang=js&"
export * from "./awards.vue?vue&type=script&lang=js&"
import style0 from "./awards.vue?vue&type=style&index=0&id=29a791b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a791b8",
  null
  
)

export default component.exports